<template>
  <!-- eslint-disable vue/max-attributes-per-line -->
  <v-row class="mb-4" dense>
    <v-col
      v-for="card in cards"
      :key="card.status"
      cols="12"
      sm="4"
    >
      <v-card
        class="kpi-card pa-4 d-flex align-center"
        :class="{ 'kpi-card--active': activeStatus === card.status }"
        outlined
        role="button"
        tabindex="0"
        :aria-label="`Фильтр по статусу: ${card.label}`"
        style="cursor: pointer"
        @click="toggle(card.status)"
        @keydown.enter="toggle(card.status)"
        @keydown.space.prevent="toggle(card.status)"
      >
        <v-avatar :color="card.color" size="40" class="mr-3 elevation-1">
          <v-icon color="white" size="22">
            {{ card.icon }}
          </v-icon>
        </v-avatar>
        <div>
          <div class="text-body-2 text--secondary">
            {{ card.label }}
          </div>
          <div class="text-h6 font-weight-bold" :class="`${card.color}--text`">
            {{ stats[card.status] !== undefined ? stats[card.status] : '—' }}
          </div>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mdiClockOutline, mdiCheckCircleOutline, mdiCloseCircleOutline } from '@mdi/js'

export default {
  name: 'BenefitsKpiBar',
  props: {
    stats: {
      type: Object,
      default: () => ({ pending: 0, approved: 0, rejected: 0 }),
    },
    activeStatus: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      cards: [
        {
          status: 'pending', label: 'На проверке', color: 'warning', icon: mdiClockOutline,
        },
        {
          status: 'approved', label: 'Одобрены', color: 'success', icon: mdiCheckCircleOutline,
        },
        {
          status: 'rejected', label: 'Отклонены', color: 'error', icon: mdiCloseCircleOutline,
        },
      ],
    }
  },
  methods: {
    toggle(status) {
      this.$emit('pick', this.activeStatus === status ? '' : status)
    },
  },
}
</script>

<style scoped>
.kpi-card {
  transition: box-shadow 0.15s, border-color 0.15s;
  user-select: none;
}
.kpi-card:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: 2px;
}
.kpi-card--active {
  box-shadow: 0 0 0 2px currentColor;
}
</style>
